<template>
    <div id="buyingManagement" class="page-content">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>买货登记</el-breadcrumb-item>
            <el-breadcrumb-item>余额明细</el-breadcrumb-item>
        </el-breadcrumb>

        <section class="seaerch-wrapper">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="每月明细" name="first"></el-tab-pane>
                <el-tab-pane label="累计明细" name="second"></el-tab-pane>
            </el-tabs>
            <el-form class="search-form" :model="queryParams" ref="queryForm">
                <el-form-item label="月份" prop="dateRange" label-width="50px" v-if="activeName == 'first'">
                    <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="monthrange" style="width: 100%;"
                        range-separator="-" start-placeholder="开始月份" end-placeholder="结束月份" size="small"
                        @change="dataChange"></el-date-picker>
                </el-form-item>
                <el-form-item label="月份" prop="dateRange" label-width="50px" v-else>
                    <el-date-picker v-model="dateRange" value-format="yyyy-MM" type="month" style="width: 100%;"
                        placeholder="选择月" size="small" @change="dataChange">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="品牌" prop="brandname" label-width="100px">
                    <el-select v-model="queryParams.brandname" filterable clearable placeholder="请选择品牌" size="small">
                        <el-option v-for="item in dispensabilityData" :key="item.bmcid"
                            :label="item.company_memoname ? item.company_memoname : item.companyname"
                            :value="item.company_memoname">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label-width="100px">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                </el-form-item>
            </el-form>
        </section>
        
        <div style="background-color: white;padding: 20px;">
            <el-row :gutter="10" class="mb8" style="padding-bottom: 20px;">
                <el-col :span="1.5">
                    <el-button size="mini" @click="importTemplate">下载数据</el-button>
                </el-col>
            </el-row>

            <el-table v-loading="loading" :data="tableData">
                <el-table-column label="月份" align="left">
                    <template slot-scope="scope">
                        {{ scope.row.months | fullTimeData }}
                    </template>
                </el-table-column>
                <el-table-column label="品牌" align="left" key="brandname" prop="brandname" />
                <el-table-column label="初始金额" align="left" key="initialamount" prop="initialamount" />
                <el-table-column label="补充金额" align="left" key="supplementaryamount" prop="supplementaryamount" />
                <el-table-column label="支付金额" align="left" key="amountpaid" prop="amountpaid" />
                <el-table-column label="买货快递费" align="left" key="ordergoodexpressfee" prop="ordergoodexpressfee" />
                <el-table-column label="运费险" align="left" key="freightinsurance" prop="freightinsurance" />

                <el-table-column label="退货运费" align="left" key="returnpaymentprice" prop="returnpaymentprice" />
                <el-table-column label="退款金额" align="left" key="refundprice" prop="refundprice" />
                <el-table-column label="转寄运费" align="left" key="forwardpaymentprice" prop="forwardpaymentprice" />
                <el-table-column label="买手佣金" align="left" key="buyerprice" prop="buyerprice" />
                <el-table-column label="退还品牌" align="left" key="refundamount" prop="refundamount" />
                <el-table-column label="剩余金额" align="left" key="residualamount" prop="residualamount" v-if="activeName != 'first'"/>
            </el-table>
            <div v-show="this.tableData.length > 0">
                <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
                    @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
export default {
    name: "returnManagement",
    components: {
        pagination
    },
    data() {
        return {
            activeName: 'first',
            elUpload: true,
            queryParams: {
                pageNo: 1,
                pageSize: 10,
                brandname: null,
            },
            title: '',
            totalNum: 0,
            currentPage: 0,
            dateRange: [],
            loading: false,
            tableData: [],
            // 表单参数
            form: {},
            taskData: [],
            returnData: [],
            returnList: [],
            bigurl: '',
            open: false,
            bigOpen: false,
            dispensabilityData: [],
            options: [{
                label: '初始金额',
                value: '初始金额',
            }, {
                label: '补充金额',
                value: '补充金额',
            }, {
                label: '退还品牌',
                value: '退还品牌',
            }],
            rules: {
                brandname: [
                    { required: true, message: '请选择品牌', trigger: 'blur' },
                ],
                transactiontype: [
                    { required: true, message: '请选择交易类型', trigger: 'blur' },
                ],
                tradingdate: [
                    { required: true, message: '请选择收入/支出日期', trigger: 'blur' },
                ],
                tradingaccount: [
                    { required: true, message: '请填写收入/支出账号', trigger: 'blur' },
                ],
                tradingscreenshot: [
                    { required: true, message: '请选择收入/支出截图', trigger: 'blur' },
                ],
                tradingprice: [
                    { required: true, message: '请填写收入/支出金额', trigger: 'blur' },
                ]
            },
        };
    },
    created() {
        this.getList();
        this.getBmcByName();
    },
    methods: {
        handleClick() {
            this.queryParams = {
                pageNo: 1,
                pageSize: 10,
                brandname: null,
            },
            this.dateRange = []
            this.getList();
        },
        bigImg(url) {
            this.open = true
            this.bigurl = url
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.queryParams.pageNo = val;
            this.getList();
        },
        getBmcByName() {
            let params = {
                name: this.form.brandname,
                type: "brm"
            }
            fetch({
                url: "/hcm/userin/getBmcListByKefuid",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
            }).then(result => {
                let res = JSON.parse(result);
                let { data } = res
                if (res.status == '10000') {
                    this.dispensabilityData = []
                    if (res.data.length > 0) {
                        this.dispensabilityData = res.data
                    } else {
                        this.$message({
                            message: '暂无当前用户',
                            type: 'warning'
                        });
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        dataChange() {
            console.log(this.dateRange)
            if (this.activeName == 'first') {
                if (!this.dateRange) {
                    this.dateRange = []
                }
                this.queryParams.begintime = this.dateRange[0] ? this.dateRange[0] : null
                this.queryParams.endtime = this.dateRange[1] ? this.dateRange[1] : null
            } else {
                if (this.dateRange && this.dateRange.length != 0) {
                    // this.queryParams.begintime = this.dateRange
                    this.queryParams.endtime = this.dateRange
                }
            }
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNo = 1;
            this.dataChange();
            this.getList();
        },
        // 数据源
        getList() {
            this.loading = true;
            let url
            if (this.activeName == 'first') {
                url = "hcm/hcmBalanceManagementsummary/getList";
            } else {
                url = "hcm/hcmBalanceManagementsummary/getListTotal";
            }
            fetch({
                url: url,
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.tableData = result.data.content;
                    this.totalNum = result.data.totalElements;
                    this.loading = false;
                }
            })
        },
        // 下载数据
        importTemplate() {
            fetch({
                url: "hcm/hcmBalanceManagementsummary/downloadBalanceManagementSummary",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "blob"
            }).then((res) => {
                //下载
                let url = window.URL.createObjectURL(new Blob([res]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '余额明细.xls')
                document.body.appendChild(link)
                link.click()
            })
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = `${val}`
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNo = `${val}`
            this.getList();
        },
    }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 50px;
    width: 50px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

#buyingManagement {
    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>